import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LOGIN_TOKEN } from "../ApiSetUp/AuthApi";
import localStoreUtil from "../ApiSetUp/localstore.util";
import { PATH_SECTION, isSuperuser, getUserData } from "../lib/permissions";
import { useAppSelector } from "../Redux/app/hooks";

export const ProtectedRoutes = () => {
  const loginToken = localStoreUtil.get_data(LOGIN_TOKEN);
  const location = useLocation();
  const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);

  if (!loginToken) {
    return <Navigate to="/login" replace />;
  }

  const userData = getUserData();
  if (isSuperuser(userData)) return <Outlet />;

  if (getPermissionList?.status === "failed") {
    return <Navigate to="/login" replace />;
  }
  if (getPermissionList?.status !== "success") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", width: "100%" }}>
        <CircularProgress size={32} sx={{ color: "#E77843" }} />
      </Box>
    );
  }

  const match = PATH_SECTION.find(([prefix]) => location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));
  if (!match) return <Outlet />;
  const section = match[1];
  if (section === "admin") return <Navigate to="/" replace />;
  const allowed = getPermissionList?.viewPermission?.includes(section) || getPermissionList?.editPermission?.includes(section);
  if (!allowed) return <Navigate to="/" replace />;

  return <Outlet />;
};
